<template>
  <div>
    <div class="container-filters">
      <input
        type="number"
        placeholder="Digite o número da apólice"
        v-model="filterApolice"
        class="input-filter"
      />
      <button class="btn-filter" v-on:click="handleClickModal">
        <i
          data-v-214d91de=""
          aria-hidden="true"
          class="v-icon icon-blue v-icon--link material-icons theme--light"
          >filter_alt</i
        ><span>Filtro</span>
      </button>
    </div>
    <div class="table-sup">
      <span class="table-sup-gp">Grupo de Modalidade</span>
      <span class="table-sup-m">Modalidade</span>
    </div>
    <div class="layout-table">
      <v-data-table
        v-if="proposals"
        :headers="headers"
        :items="filteredProposals"
        hide-actions
        :no-data-text="msgNoResults"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr @click="routerNewTarget(props.item.cd_proposta, props.item.cd_produto)">
            <td class="text-xs-left">
              <p
                style="
                  min-width: 400px;
                  width: 400px;
                  max-width: 400px;
                  color: #191737;
                  font-weight: 600;
                "
              >
                {{ props.item.grupo_modalidade }}
              </p>
              <strong>{{ props.item.cd_apolice }}</strong>
            </td>
            <td class="text-xs-left">
              <p
                style="
                  min-width: 400px;
                  width: 400px;
                  max-width: 400px;
                  color: #191737;
                  font-weight: 600;
                "
              >
                {{ props.item.grupo_modalidade }}
              </p>
              <strong>{{ props.item.nr_endosso }}</strong>
            </td>
            <td class="text-xs-left">{{ props.item.tipo_apolice }}</td>
            <td class="text-xs-left">{{ props.item.nm_status }}</td>
            <td class="text-xs-left">
              {{ formatDate(props.item.dt_emissao) }}
            </td>
            <td class="text-xs-left">
              {{ formatDate(props.item.dt_inicio_vigencia) }}
            </td>
            <td class="text-xs-left">
              {{ toMoneyString(props.item.vl_importancia_segurado) }}
            </td>
            <td class="text-xs-left">
              {{ toMoneyString(props.item.vl_premio) }}
            </td>
            <td
              style="min-width: 600px; width: 700px; max-width: 800px"
              class="text-xs-left"
            >
              {{ props.item.segurado.toUpperCase() }}
            </td>
          </tr>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Sua pesquisa por "{{}}" não encontrou resultados.
        </v-alert>
      </v-data-table>
      <div class="box-pagination">
        <!-- Botão de excel -->
        <div class="layout-excel">
          <div>
            <button type="button" v-on:click="download">
              <img
                :src="require('../assets/excel.png')"
                alt="Baixar dados em planilha"
                title="Baixar dados em planilha"
              />
            </button>
          </div>
        </div>

        <div class="layout-pagination">
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            :total-visible="10"
            color="#061d45"
          ></v-pagination>
        </div>
      </div>
    </div>

    <!-- Início Modal de filtro -->
    <v-dialog v-model="showDialog" v-if="showDialog" :max-width="'680'">
      <base-modal>
        <div class="box-filter">
          <div class="box-filter-radio">
            <label for="radioFilter">Apólices</label>
            <v-radio-group
              id="radioFilter"
              v-model="filterRadio"
              class="radio-button hidden"
              row
            >
              <v-radio label="Vigentes" :value="true"></v-radio>
              <v-radio label="Todas" :value="false"></v-radio>
            </v-radio-group>
          </div>

          <div class="box-filter-inputs">
            <v-select
              :items="itensGrupoModalidade"
              v-model="grupoModalidade"
              label="Grupo de Modalidade"
              dense
              class="select"
            ></v-select>

            <v-select
              :items="itensModalidade"
              v-model="modalidade"
              label="Modalidade"
              dense
              class="select"
            ></v-select>

            <p>Período de Vigência</p>
            <div class="box-filter-date">
              <div class="input-date">
                <input
                  class="inputDate"
                  type="date"
                  v-model="dateVigenciaInicio"
                />
              </div>
              <span>à</span>
              <div class="input-date">
                <input
                  class="inputDate"
                  type="date"
                  v-model="dateVigenciaFim"
                />
              </div>
            </div>
            <p>Data de Emissão</p>
            <div class="box-filter-date">
              <div class="input-date">
                <input
                  class="inputDate"
                  type="date"
                  v-model="dateEmissaoInicio"
                />
              </div>
              <span>à</span>
              <div class="input-date">
                <input class="inputDate" type="date" v-model="dateEmissaoFim" />
              </div>
            </div>
            <div>
              <v-text-field
                v-model="segurado"
                label="Segurado"
                placeholder="Nome do segurado"
              ></v-text-field>
            </div>
          </div>
        </div>
        <div class="box-buttons">
          <button class="btn-code btn-clear" @click="clearFilters">
            Limpar Filtros
          </button>
          <button class="btn-code btn-cancel" @click="calcel">Cancelar</button>
          <button class="btn-code btn-apply" @click="submit">Aplicar</button>
        </div>
      </base-modal>
    </v-dialog>
    <!-- Fim Modal de filtro -->
  </div>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
import { mapActions } from "vuex";
import { formatDate, toMoneyString } from "@/libs/utils";
import XLSX from 'xlsx';

export default {
  name: "TomadorApolice",
  mixins: [ViewMixin],
  props: ["pages", "policies", "idTomador", "cnpj-tomador", "filtros"],
  data: () => ({
    XLSX,
    json_name_xls: '',
    json_data_format: [],
    error: {},
    formatDate,
    toMoneyString,
    showDialog: false,
    proposals: [],
    msgNoResults: '',
    filterApolice: '',

    filterRadio: true,

    dateVigenciaInicio: '',
    dateVigenciaFim: '',

    dateEmissaoInicio: '',
    dateEmissaoFim: '',

    segurado: null,

    /* Dados do combo grupo de modalidade */
    grupoModalidade: null,
    modalidade: null,
    itensGrupoModalidade:[],
    itensModalidade: [],

    loading: false,
    pagination: {},

    //paginação das apólices
    currentPage: 1,
    totalPages: null,

    headers: [
      {
        text: "Apólice",
        align: "left",
        sortable: false,
      },
      {
        text: "Endosso",
        align: "left",
        sortable: false,
      },
      {
        text: "Tipo",
        align: "left",
        sortable: false,
      },
      {
        text: "Status",
        align: "left",
        sortable: false,
      },
      {
        text: "Data Emissão",
        align: "left",
        sortable: false,
      },
      {
        text: "Período de Vigência",
        align: "left",
        sortable: false,
      },
      {
        text: "Importância Segurada",
        align: "left",
        sortable: false,
      },
      {
        text: "Prêmio",
        align: "left",
        sortable: false,
      },
      {
        text: "Segurado",
        align: "left",
        sortable: false,
      },
    ],
  }),

  created(){
    //Valores das páginas
    this.proposals = this.policies;
    this.prepareJSONForExcel(this.proposals);
    this.currentPage = this.pages.pg;
    this.totalPages = this.pages.total_pg;

    this.itensGrupoModalidade = this.filtros.grupo_credito;
    this.itensModalidade = this.filtros.modalidade;
    this.msgNoResults = 'Nenhuma apólice encontrada';
  },

  //Observo a mudança da variável currentPage e assim realizo a consulta da página selecionada
  watch: {
    currentPage(){
      Promise.all([this.handleCurrentPage(this.currentPage)]);
    },
  },

  computed: {

    filteredProposals(){
      let items = this.proposals;
      let filters = this.filterApolice;

      if (items.length == 0) return [];

      if (!filters) {
        return items;
      }

      let tempItems = items;

      if (filters) {
        tempItems = tempItems.filter( (item) => {
         return (item.cd_apolice && ((item.cd_apolice+'').toLowerCase().indexOf(filters.toLowerCase()) !== -1))
        });
      }
      this.prepareJSONForExcel(tempItems);

      return tempItems;
    },

    computedDateFormattedVI(){
      return formatDate(this.dateVigenciaInicio);
    },
    computedDateFormattedVF () {
      return formatDate(this.dateVigenciaFim);
    },

    computedDateFormattedEI(){
     return formatDate(this.dateEmissaoInicio);
    },
    computedDateFormattedEF () {
      return formatDate(this.dateEmissaoFim);
    },
  },

  methods: {

    download() {
      const data = XLSX.utils.json_to_sheet(this.json_data_format);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, 'data');
      XLSX.writeFile(wb,`${this.json_name_xls}.xlsx`);
    },

    prepareJSONForExcel(data){
      this.json_name_xls = `${this.$route.params.takerCNPJ}-${new Date().toISOString().substr(0, 10)}`;

      //Novo processo para formatar as apólices filtradas para enviar ao excel
      this.json_data_format = data.map(item => {
        return {
          'Nº Apólice': item.cd_apolice,
          'Nº Endosso': item.nr_endosso,
          'Tipo da Apólice': item.tipo_apolice,
          'Status': item.nm_status,
          'Data de Emissão': this.formatDate(item.dt_emissao),
          'Início da Vigência': this.formatDate(item.dt_inicio_vigencia),
          'Fim da Vigência': this.formatDate(item.dt_fim_vigencia),
          'Valor Importância Segurado': this.toMoneyString(item.vl_importancia_segurado).replace(",", "."),
          'Valor Prêmio': this.toMoneyString(item.vl_premio).replace(",", "."),
          'Segurado': item.segurado.toUpperCase(),
          'Nº Ramo': item.nr_ramo,
          'Modalidade': item.modalidade.replace(",", "-"),
          'Grupo Modalidade': item.grupo_modalidade.replace(",", " -"),
        }
      });
    },

    routerNewTarget(cd_proposta, cd_produto){
      let router = this.$router.resolve({path: `/proposta/${cd_proposta}/${cd_produto}`,});
      let href = router.href;
      window.open(href, '_blank');
    },

    handleClickModal(){
      this.showDialog = true;
    },

    async handleCurrentPage(page){
      let takerCNPJ = this.$route.params.takerCNPJ;
      let cPage = page;
      try {
        this.showLoadingAskWait();
        //dados da páginação e as propostas
        let response = await this.$store.dispatch("GET_TAKER_APOLICES", {
          cnpj: takerCNPJ,
          pagina_atual: cPage
        });
        this.proposals = response.apolices
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
        this.hideLoadingAskWait();
      }
    },

    async getApolicesFromFilter(segurado, vigencia_inicio, vigencia_fim, emissao_inicio, emissao_fim, modalidade, grupo_modalidade, vigente){
      let takerCNPJ = this.$route.params.takerCNPJ;
      try {
        this.showLoadingAskWait();
        //dados da páginação e as propostas
        let response = await this.$store.dispatch("GET_TAKER_APOLICES", {
          cnpj: takerCNPJ,
          segurado,
          vigencia_inicio,
          vigencia_fim,
          emissao_inicio,
          emissao_fim,
          modalidade,
          grupo_modalidade,
          vigente,
        });
        this.proposals = response.apolices
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
        this.hideLoadingAskWait();
      }
    },

    clearFilters(){
      this.filterRadio = true;
      this.dateVigenciaInicio = '';
      this.dateVigenciaFim = '';
      this.dateEmissaoInicio = '';
      this.dateEmissaoFim = '';
      this.segurado = null;
      this.grupoModalidade = null;
      this.modalidade = null;
    },

    calcel(){
      this.showDialog = false;
      this.clearFilters();
    },

    submit(event){
      event.preventDefault();

      const segurado = this.segurado;
      const vigencia_inicio = this.dateVigenciaInicio.trim() ? this.dateVigenciaInicio : null;
      const vigencia_fim = this.dateVigenciaFim.trim() ? this.dateVigenciaFim : null;
      const emissao_inicio = this.dateEmissaoInicio.trim() ? this.dateEmissaoInicio : null;
      const emissao_fim = this.dateEmissaoFim.trim() ? this.dateEmissaoFim : null;
      const modalidade = this.modalidade;
      const grupo_modalidade = this.grupoModalidade;
      const vigente = this.filterRadio;

      try {
        Promise.all([this.getApolicesFromFilter(segurado, vigencia_inicio, vigencia_fim, emissao_inicio, emissao_fim, modalidade, grupo_modalidade, vigente)])
        this.showDialog = false;
        this.clearFilters();
        this.msgNoResults = 'Nenhuma apólice foi encontrada para os filtros selecionados';
      } catch (error) {
      }
    }
  },

};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  width: 100%;
}

.layout-table {
  display: inline-block;
  width: 100%;

  .box-pagination {
    display: flex;
    flex-direction: row;
    background-color: #fff;
    margin: 8px 0;
    align-items: center;
    box-shadow: 1px 2px rgba($color: #000000, $alpha: 0.2);

    img {
      width: 48px;
    }

    .layout-excel {
      width: 5%;
      margin-top: 6px;
      margin-left: 8px;
    }

    .layout-pagination {
      width: 95%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  td {
    cursor: pointer;
  }
}

.table-sup {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  height: 60px;
  background-color: #fff;
  border: 1px solid #ddd;

  .table-sup-gp,
  .table-sup-m {
    color: #191737;
    font-weight: 600;
  }
  .table-sup-gp {
    display: flex;
    margin-left: 24px;
    width: 445px;
    max-width: 445px;
  }
}

.container-filters {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1%;
  justify-content: space-between;
  align-items: center;

  .input-filter {
    width: 80%;
    height: 45px;
    margin: 0 1% 0 0;
    height: 50px;
    padding: 20px;
    border: 1px solid #ddd;
    font-size: 1.2rem;
    border-radius: 3px;
    box-shadow: 0 0 2px 0 rgba($color: #000000, $alpha: 0.2);
    background-color: #fff;
  }

  .input-filter:focus {
    outline: 0;
  }

  .btn-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-color: rgba(0, 0, 0, 0.42);
    background-color: #f1e41e;
    color: #061d45;
    border-radius: 48px;
    padding: 8px 0;
    width: 19%;
    height: 48px;
    box-shadow: 1px 2px rgba($color: #000000, $alpha: 0.2);
    font-size: 1.14rem;

    td {
      cursor: pointer;
    }

    i {
      color: #061d45;
    }

    span {
      margin-top: 3px;
    }
  }

  .btn-filter:hover {
    background-color: #061d45;
    color: #fff;

    i {
      color: #fff;
    }
  }

  .line-sup-table {
    width: 100;
    height: 45px;
    background-color: #fff;
  }

  .items-line-sup {
    min-width: 300px;
    width: 300px;
    max-width: 350px;
    color: #191737;
    font-weight: 600;
  }
}

.box-filter {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2px;

  .box-filter-radio {
    width: 100%;
    display: flex;
    flex-direction: column;

    label {
      color: rgba(0, 0, 0, 0.87);
    }

    .radio-button {
      margin-top: 1%;
    }
  }

  .box-filter-inputs {
    margin: 2% 0;
  }

  .box-filter-date {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 2px;
    margin: 14px 0;

    .input-date {
      margin: 8px 0;
      width: 100%;

      .inputDate {
        border-bottom: 1px solid #ddd;
        padding: 2px;
        font-size: 1.1rem;
        width: 90%;
      }
    }

    span {
      width: 10%;
      line-height: 1.5;
    }
  }

  p {
    margin: 1% 0;
    color: rgba(0, 0, 0, 0.87);
  }
}

.box-buttons {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  .btn-code {
    width: 32%;
    border: 0;
    font-size: 1.14rem;
    font-weight: bold;
    text-align: center;
    height: 45px;
    border-radius: 45px;
    box-shadow: 0 2px 4px 0 rgba($color: #000000, $alpha: 0.5);
    background-color: #061d45;
    color: #fff;
    transition: 0.1s;
  }

  .btn-apply:not(:hover) {
    background-color: #f1e41e;
    color: #061d45;
  }

  .btn-cancel:hover {
    background-color: #f44336 !important;
    color: #fff;
  }

  .btn-clear {
    background-color: #fff !important;
    color: #061d45;
  }

  .btn-clear:hover {
    background-color: #061d45 !important;
    border-color: #f44336 !important;
    color: #fff;
  }
}

@media (max-width: 595px) {
  .table-sup {
    display: none;
  }
}

@media (max-width: 520px) {
  .container-filters {
    flex-direction: column;

    .input-filter {
      width: 100%;
      margin-bottom: 4%;
    }

    .btn-filter {
      width: 100%;
      margin-bottom: 3%;
      box-shadow: 4px rgba(0, 0, 0, 0.1);
    }
  }
}

v-data-footer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// ./src/components/TomadorApolice.vue